var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53673 2.55669C5.53639 3.23443 5.27075 3.88427 4.79822 4.36327C4.3257 4.84226 3.68502 5.11117 3.0171 5.11083C2.34919 5.11049 1.70877 4.84093 1.23672 4.36146C0.764673 3.88199 0.499666 3.23187 0.5 2.55414C0.500334 1.8764 0.765981 1.22655 1.2385 0.74756C1.71102 0.268567 2.35171 -0.000338549 3.01962 3.19889e-07C3.68753 0.000339189 4.32796 0.269894 4.80001 0.749367C5.27205 1.22884 5.53706 1.87895 5.53673 2.55669ZM5.61228 7.00311H0.575551V23H5.61228V7.00311ZM13.5703 7.00311H8.55876V23H13.5199V14.6055C13.5199 9.92906 19.5262 9.49464 19.5262 14.6055V23H24.5V12.8678C24.5 4.98433 15.6102 5.27821 13.5199 9.14966L13.5703 7.00311Z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.9861d7e189b75cef4fe11ce115616954.svg";
export { ForwardRef as ReactComponent };